import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {
    green500,
    green600,
    greyishBlue500,
    greyishBlue700,
} from "assets/jss/main";

StatusTag.propTypes = {
    status: PropTypes.bool
};

function StatusTag({status = false}) {
    let color;
    let dotColor;

    switch (true) {
        case status === true:
            color = green600;
            dotColor = green500;
            break;
        default:
            color = greyishBlue700;
            dotColor = greyishBlue500;
    }

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
        }}>
            <span style={{
                display: 'inline-block',
                width: '6px',
                height: '6px',
                borderRadius: '50%',
                background: dotColor
            }} />
            <span style={{
                color: color,
                fontSize: '11px',
                fontWeight: 500
            }}>
                {status === true
                    ? <FormattedMessage id="dashboard.topProducts.mobile.status.active" />
                    : <FormattedMessage id="dashboard.topProducts.mobile.status.inactive" />}
            </span>
        </div>
    );
}

export default StatusTag;
